import { render, staticRenderFns } from "./globalNewParams.vue?vue&type=template&id=76b1c5de&scoped=true"
import script from "./globalNewParams.vue?vue&type=script&lang=js"
export * from "./globalNewParams.vue?vue&type=script&lang=js"
import style0 from "./globalNewParams.vue?vue&type=style&index=0&id=76b1c5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b1c5de",
  null
  
)

export default component.exports